import { AttachmentPreviewHeader } from '@components/icons/AttachmentPreviewHeader'
import { Modal } from '@components/Modal'
import { useTranslation } from 'react-i18next'

import { Professional } from '@/types/consultation'

interface ProfessionalDetailProps {
  professional: Professional
  onClose: () => void
}

export const ProfessionalDetail = ({ professional, onClose }: ProfessionalDetailProps) => {
  const { t } = useTranslation()
  return (
    <Modal
      header={{
        icon: <AttachmentPreviewHeader customClassName="text-primary" />,
        title: t(`professional_title_${professional.gender}`, {
          name: professional.name
        })
      }}
      onClose={onClose}
      dataTestId="professional-detail-modal"
    >
      <iframe src={professional.profileUrl} className="w-full flex-1 rounded bg-gray-background p-2 shadow-strong" />
    </Modal>
  )
}
